import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=0b336107&scoped=true&lang=pug&"
import script from "./CustomerView.vue?vue&type=script&lang=js&"
export * from "./CustomerView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerView.vue?vue&type=style&index=0&id=0b336107&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b336107",
  null
  
)

export default component.exports